import { Hero } from "@/components/home/Hero";
import { Story, Pains } from "@/components/home/Story";
import { Method } from "@/components/home/Method";
import { QuizSection } from "@/components/home/QuizSection";
import { ProductReveal } from "@/components/home/ProductReveal";
import { WhatYouGet } from "@/components/home/WhatYouGet";
import { PricingSection, GuaranteeSection, FounderSection, FaqSection } from "@/components/home/Sections";
import { FinalCta, MobileBuyBar } from "@/components/home/FinalCta";
import { Testimonials } from "@/components/site/Testimonials";
import { Marquee } from "@/components/site/Marquee";
import { useSeo } from "@/lib/useSeo";
import { homeSchema } from "@/lib/schema";

const HOME_DESC = "The First Mover Method: a step-by-step system for beginners to spot a market shift early and build a first business around it.";

export default function Home() {
  useSeo(null, HOME_DESC, homeSchema(HOME_DESC));
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Story />
      <Pains />
      <Method />
      <QuizSection />
      <ProductReveal />
      <WhatYouGet />
      <PricingSection />
      <GuaranteeSection />
      <Testimonials />
      <FounderSection />
      <FaqSection />
      <FinalCta />
      <MobileBuyBar />
    </main>
  );
}
